import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

export const mapPartialToFullCompetitor = (
  partialCompetitor: Partial<ISobCompetitor>
): ISobCompetitor => {
  return {
    CompetitorID: partialCompetitor.CompetitorID ?? '',
    CompetitorName: partialCompetitor.CompetitorName ?? '',
    EntryId: partialCompetitor.EntryId ?? '',
    Name: partialCompetitor.Name ?? '',
    NameKey: partialCompetitor.NameKey ?? '',
    ParentId: partialCompetitor.ParentId ?? null,
    SortOrder: partialCompetitor.SortOrder ?? null,
    IsExpanded: partialCompetitor.IsExpanded ?? null,

    // Current Year Q1
    CurrentYearQ1ActualsNdpLocalCurrency:
      partialCompetitor.CurrentYearQ1ActualsNdpLocalCurrency ?? null,
    CurrentYearQ1ActualsNdpUSD: partialCompetitor.CurrentYearQ1ActualsNdpUSD ?? null,
    CurrentYearQ1ActualsNetLocalCurrency:
      partialCompetitor.CurrentYearQ1ActualsNetLocalCurrency ?? null,
    CurrentYearQ1ActualsNetUSD: partialCompetitor.CurrentYearQ1ActualsNetUSD ?? null,
    CurrentYearQ1ActualsSob: partialCompetitor.CurrentYearQ1ActualsSob ?? null,
    CurrentYearQ1YoYActualsSob: partialCompetitor.CurrentYearQ1YoYActualsSob ?? null,
    CurrentYearQ1YoYActualsNetUSD: partialCompetitor.CurrentYearQ1YoYActualsNetUSD ?? null,
    CurrentYearQ1YoYActualsNdpUSD: partialCompetitor.CurrentYearQ1YoYActualsNdpUSD ?? null,
    CurrentYearQ1YoYActualsNetLocalCurrency:
      partialCompetitor.CurrentYearQ1YoYActualsNetLocalCurrency ?? null,
    CurrentYearQ1YoYActualsNdpLocalCurrency:
      partialCompetitor.CurrentYearQ1YoYActualsNdpLocalCurrency ?? null,

    // Current Year Q2
    CurrentYearQ2ActualsNdpLocalCurrency:
      partialCompetitor.CurrentYearQ2ActualsNdpLocalCurrency ?? null,
    CurrentYearQ2ActualsNdpUSD: partialCompetitor.CurrentYearQ2ActualsNdpUSD ?? null,
    CurrentYearQ2ActualsNetLocalCurrency:
      partialCompetitor.CurrentYearQ2ActualsNetLocalCurrency ?? null,
    CurrentYearQ2ActualsNetUSD: partialCompetitor.CurrentYearQ2ActualsNetUSD ?? null,
    CurrentYearQ2ActualsSob: partialCompetitor.CurrentYearQ2ActualsSob ?? null,
    CurrentYearQ2YoYActualsSob: partialCompetitor.CurrentYearQ2YoYActualsSob ?? null,
    CurrentYearQ2YoYActualsNetUSD: partialCompetitor.CurrentYearQ2YoYActualsNetUSD ?? null,
    CurrentYearQ2YoYActualsNdpUSD: partialCompetitor.CurrentYearQ2YoYActualsNdpUSD ?? null,
    CurrentYearQ2YoYActualsNetLocalCurrency:
      partialCompetitor.CurrentYearQ2YoYActualsNetLocalCurrency ?? null,
    CurrentYearQ2YoYActualsNdpLocalCurrency:
      partialCompetitor.CurrentYearQ2YoYActualsNdpLocalCurrency ?? null,

    // Current Year Q3
    CurrentYearQ3ActualsNdpLocalCurrency:
      partialCompetitor.CurrentYearQ3ActualsNdpLocalCurrency ?? null,
    CurrentYearQ3ActualsNdpUSD: partialCompetitor.CurrentYearQ3ActualsNdpUSD ?? null,
    CurrentYearQ3ActualsNetLocalCurrency:
      partialCompetitor.CurrentYearQ3ActualsNetLocalCurrency ?? null,
    CurrentYearQ3ActualsNetUSD: partialCompetitor.CurrentYearQ3ActualsNetUSD ?? null,
    CurrentYearQ3ActualsSob: partialCompetitor.CurrentYearQ3ActualsSob ?? null,
    CurrentYearQ3YoYActualsSob: partialCompetitor.CurrentYearQ3YoYActualsSob ?? null,
    CurrentYearQ3YoYActualsNetUSD: partialCompetitor.CurrentYearQ3YoYActualsNetUSD ?? null,
    CurrentYearQ3YoYActualsNdpUSD: partialCompetitor.CurrentYearQ3YoYActualsNdpUSD ?? null,
    CurrentYearQ3YoYActualsNetLocalCurrency:
      partialCompetitor.CurrentYearQ3YoYActualsNetLocalCurrency ?? null,
    CurrentYearQ3YoYActualsNdpLocalCurrency:
      partialCompetitor.CurrentYearQ3YoYActualsNdpLocalCurrency ?? null,

    // Current Year Q4
    CurrentYearQ4ActualsNdpLocalCurrency:
      partialCompetitor.CurrentYearQ4ActualsNdpLocalCurrency ?? null,
    CurrentYearQ4ActualsNdpUSD: partialCompetitor.CurrentYearQ4ActualsNdpUSD ?? null,
    CurrentYearQ4ActualsNetLocalCurrency:
      partialCompetitor.CurrentYearQ4ActualsNetLocalCurrency ?? null,
    CurrentYearQ4ActualsNetUSD: partialCompetitor.CurrentYearQ4ActualsNetUSD ?? null,
    CurrentYearQ4ActualsSob: partialCompetitor.CurrentYearQ4ActualsSob ?? null,
    CurrentYearQ4YoYActualsSob: partialCompetitor.CurrentYearQ4YoYActualsSob ?? null,
    CurrentYearQ4YoYActualsNetUSD: partialCompetitor.CurrentYearQ4YoYActualsNetUSD ?? null,
    CurrentYearQ4YoYActualsNdpUSD: partialCompetitor.CurrentYearQ4YoYActualsNdpUSD ?? null,
    CurrentYearQ4YoYActualsNetLocalCurrency:
      partialCompetitor.CurrentYearQ4YoYActualsNetLocalCurrency ?? null,
    CurrentYearQ4YoYActualsNdpLocalCurrency:
      partialCompetitor.CurrentYearQ4YoYActualsNdpLocalCurrency ?? null,

    // Current Year FY
    CurrentYearFYActualsNdpLocalCurrency:
      partialCompetitor.CurrentYearFYActualsNdpLocalCurrency ?? null,
    CurrentYearFYActualsNdpUSD: partialCompetitor.CurrentYearFYActualsNdpUSD ?? null,
    CurrentYearFYActualsNetLocalCurrency:
      partialCompetitor.CurrentYearFYActualsNetLocalCurrency ?? null,
    CurrentYearFYActualsNetUSD: partialCompetitor.CurrentYearFYActualsNetUSD ?? null,
    CurrentYearFYActualsSob: partialCompetitor.CurrentYearFYActualsSob ?? null,
    CurrentYearFYYoYActualsSob: partialCompetitor.CurrentYearFYYoYActualsSob ?? null,
    CurrentYearFYYoYActualsNetUSD: partialCompetitor.CurrentYearFYYoYActualsNetUSD ?? null,
    CurrentYearFYYoYActualsNdpUSD: partialCompetitor.CurrentYearFYYoYActualsNdpUSD ?? null,
    CurrentYearFYYoYActualsNetLocalCurrency:
      partialCompetitor.CurrentYearFYYoYActualsNetLocalCurrency ?? null,
    CurrentYearFYYoYActualsNdpLocalCurrency:
      partialCompetitor.CurrentYearFYYoYActualsNdpLocalCurrency ?? null,

    // Previous Year Q1
    PrevYearQ1ActualsNdpLocalCurrency: partialCompetitor.PrevYearQ1ActualsNdpLocalCurrency ?? null,
    PrevYearQ1ActualsNdpUSD: partialCompetitor.PrevYearQ1ActualsNdpUSD ?? null,
    PrevYearQ1ActualsNetLocalCurrency: partialCompetitor.PrevYearQ1ActualsNetLocalCurrency ?? null,
    PrevYearQ1ActualsNetUSD: partialCompetitor.PrevYearQ1ActualsNetUSD ?? null,
    PrevYearQ1ActualsSob: partialCompetitor.PrevYearQ1ActualsSob ?? null,
    PrevYearQ1YoYActualsSob: partialCompetitor.PrevYearQ1YoYActualsSob ?? null,
    PrevYearQ1YoYActualsNetUSD: partialCompetitor.PrevYearQ1YoYActualsNetUSD ?? null,
    PrevYearQ1YoYActualsNdpUSD: partialCompetitor.PrevYearQ1YoYActualsNdpUSD ?? null,
    PrevYearQ1YoYActualsNetLocalCurrency:
      partialCompetitor.PrevYearQ1YoYActualsNetLocalCurrency ?? null,
    PrevYearQ1YoYActualsNdpLocalCurrency:
      partialCompetitor.PrevYearQ1YoYActualsNdpLocalCurrency ?? null,

    // Previous Year Q2
    PrevYearQ2ActualsNdpLocalCurrency: partialCompetitor.PrevYearQ2ActualsNdpLocalCurrency ?? null,
    PrevYearQ2ActualsNdpUSD: partialCompetitor.PrevYearQ2ActualsNdpUSD ?? null,
    PrevYearQ2ActualsNetLocalCurrency: partialCompetitor.PrevYearQ2ActualsNetLocalCurrency ?? null,
    PrevYearQ2ActualsNetUSD: partialCompetitor.PrevYearQ2ActualsNetUSD ?? null,
    PrevYearQ2ActualsSob: partialCompetitor.PrevYearQ2ActualsSob ?? null,
    PrevYearQ2YoYActualsSob: partialCompetitor.PrevYearQ2YoYActualsSob ?? null,
    PrevYearQ2YoYActualsNetUSD: partialCompetitor.PrevYearQ2YoYActualsNetUSD ?? null,
    PrevYearQ2YoYActualsNdpUSD: partialCompetitor.PrevYearQ2YoYActualsNdpUSD ?? null,
    PrevYearQ2YoYActualsNetLocalCurrency:
      partialCompetitor.PrevYearQ2YoYActualsNetLocalCurrency ?? null,
    PrevYearQ2YoYActualsNdpLocalCurrency:
      partialCompetitor.PrevYearQ2YoYActualsNdpLocalCurrency ?? null,

    // Previous Year Q3
    PrevYearQ3ActualsNdpLocalCurrency: partialCompetitor.PrevYearQ3ActualsNdpLocalCurrency ?? null,
    PrevYearQ3ActualsNdpUSD: partialCompetitor.PrevYearQ3ActualsNdpUSD ?? null,
    PrevYearQ3ActualsNetLocalCurrency: partialCompetitor.PrevYearQ3ActualsNetLocalCurrency ?? null,
    PrevYearQ3ActualsNetUSD: partialCompetitor.PrevYearQ3ActualsNetUSD ?? null,
    PrevYearQ3ActualsSob: partialCompetitor.PrevYearQ3ActualsSob ?? null,
    PrevYearQ3YoYActualsSob: partialCompetitor.PrevYearQ3YoYActualsSob ?? null,
    PrevYearQ3YoYActualsNetUSD: partialCompetitor.PrevYearQ3YoYActualsNetUSD ?? null,
    PrevYearQ3YoYActualsNdpUSD: partialCompetitor.PrevYearQ3YoYActualsNdpUSD ?? null,
    PrevYearQ3YoYActualsNetLocalCurrency:
      partialCompetitor.PrevYearQ3YoYActualsNetLocalCurrency ?? null,
    PrevYearQ3YoYActualsNdpLocalCurrency:
      partialCompetitor.PrevYearQ3YoYActualsNdpLocalCurrency ?? null,

    // Previous Year Q4
    PrevYearQ4ActualsNdpLocalCurrency: partialCompetitor.PrevYearQ4ActualsNdpLocalCurrency ?? null,
    PrevYearQ4ActualsNdpUSD: partialCompetitor.PrevYearQ4ActualsNdpUSD ?? null,
    PrevYearQ4ActualsNetLocalCurrency: partialCompetitor.PrevYearQ4ActualsNetLocalCurrency ?? null,
    PrevYearQ4ActualsNetUSD: partialCompetitor.PrevYearQ4ActualsNetUSD ?? null,
    PrevYearQ4ActualsSob: partialCompetitor.PrevYearQ4ActualsSob ?? null,
    PrevYearQ4YoYActualsSob: partialCompetitor.PrevYearQ4YoYActualsSob ?? null,
    PrevYearQ4YoYActualsNetUSD: partialCompetitor.PrevYearQ4YoYActualsNetUSD ?? null,
    PrevYearQ4YoYActualsNdpUSD: partialCompetitor.PrevYearQ4YoYActualsNdpUSD ?? null,
    PrevYearQ4YoYActualsNetLocalCurrency:
      partialCompetitor.PrevYearQ4YoYActualsNetLocalCurrency ?? null,
    PrevYearQ4YoYActualsNdpLocalCurrency:
      partialCompetitor.PrevYearQ4YoYActualsNdpLocalCurrency ?? null,

    // Previous Year FY
    PrevYearFYActualsNdpLocalCurrency: partialCompetitor.PrevYearFYActualsNdpLocalCurrency ?? null,
    PrevYearFYActualsNdpUSD: partialCompetitor.PrevYearFYActualsNdpUSD ?? null,
    PrevYearFYActualsNetLocalCurrency: partialCompetitor.PrevYearFYActualsNetLocalCurrency ?? null,
    PrevYearFYActualsNetUSD: partialCompetitor.PrevYearFYActualsNetUSD ?? null,
    PrevYearFYActualsSob: partialCompetitor.PrevYearFYActualsSob ?? null,
    PrevYearFYYoYActualsSob: partialCompetitor.PrevYearFYYoYActualsSob ?? null,
    PrevYearFYYoYActualsNetUSD: partialCompetitor.PrevYearFYYoYActualsNetUSD ?? null,
    PrevYearFYYoYActualsNdpUSD: partialCompetitor.PrevYearFYYoYActualsNdpUSD ?? null,
    PrevYearFYYoYActualsNetLocalCurrency:
      partialCompetitor.PrevYearFYYoYActualsNetLocalCurrency ?? null,
    PrevYearFYYoYActualsNdpLocalCurrency:
      partialCompetitor.PrevYearFYYoYActualsNdpLocalCurrency ?? null,

    //prev prev year
    PrevPrevYearQ1ActualsSob: partialCompetitor.PrevPrevYearQ1ActualsSob ?? null,
    PrevPrevYearQ2ActualsSob: partialCompetitor.PrevPrevYearQ2ActualsSob ?? null,
    PrevPrevYearQ3ActualsSob: partialCompetitor.PrevPrevYearQ3ActualsSob ?? null,
    PrevPrevYearQ4ActualsSob: partialCompetitor.PrevPrevYearQ4ActualsSob ?? null,
    PrevPrevYearFYActualsSob: partialCompetitor.PrevPrevYearFYActualsSob ?? null,
    PrevPrevYearQ1ActualsNetUSD: partialCompetitor.PrevPrevYearQ1ActualsNetUSD ?? null,
    PrevPrevYearQ2ActualsNetUSD: partialCompetitor.PrevPrevYearQ2ActualsNetUSD ?? null,
    PrevPrevYearQ3ActualsNetUSD: partialCompetitor.PrevPrevYearQ3ActualsNetUSD ?? null,
    PrevPrevYearQ4ActualsNetUSD: partialCompetitor.PrevPrevYearQ4ActualsNetUSD ?? null,
    PrevPrevYearQ1ActualsNdpUSD: partialCompetitor.PrevPrevYearQ1ActualsNdpUSD ?? null,
    PrevPrevYearQ2ActualsNdpUSD: partialCompetitor.PrevPrevYearQ2ActualsNdpUSD ?? null,
    PrevPrevYearQ3ActualsNdpUSD: partialCompetitor.PrevPrevYearQ3ActualsNdpUSD ?? null,
    PrevPrevYearQ4ActualsNdpUSD: partialCompetitor.PrevPrevYearQ4ActualsNdpUSD ?? null,
    PrevPrevYearQ1ActualsNetLocalCurrency:
      partialCompetitor.PrevPrevYearQ1ActualsNetLocalCurrency ?? null,
    PrevPrevYearQ2ActualsNetLocalCurrency:
      partialCompetitor.PrevPrevYearQ2ActualsNetLocalCurrency ?? null,
    PrevPrevYearQ3ActualsNetLocalCurrency:
      partialCompetitor.PrevPrevYearQ3ActualsNetLocalCurrency ?? null,
    PrevPrevYearQ4ActualsNetLocalCurrency:
      partialCompetitor.PrevPrevYearQ4ActualsNetLocalCurrency ?? null,
    PrevPrevYearQ1ActualsNdpLocalCurrency:
      partialCompetitor.PrevPrevYearQ1ActualsNdpLocalCurrency ?? null,
    PrevPrevYearQ2ActualsNdpLocalCurrency:
      partialCompetitor.PrevPrevYearQ2ActualsNdpLocalCurrency ?? null,
    PrevPrevYearQ3ActualsNdpLocalCurrency:
      partialCompetitor.PrevPrevYearQ3ActualsNdpLocalCurrency ?? null,
    PrevPrevYearQ4ActualsNdpLocalCurrency:
      partialCompetitor.PrevPrevYearQ4ActualsNdpLocalCurrency ?? null,
    PrevPrevYearFYActualsNetUSD: partialCompetitor.PrevPrevYearFYActualsNetUSD ?? null,
    PrevPrevYearFYActualsNdpUSD: partialCompetitor.PrevPrevYearFYActualsNdpUSD ?? null,
    PrevPrevYearFYActualsNetLocalCurrency:
      partialCompetitor.PrevPrevYearFYActualsNetLocalCurrency ?? null,
    PrevPrevYearFYActualsNdpLocalCurrency:
      partialCompetitor.PrevPrevYearFYActualsNdpLocalCurrency ?? null,

    //qoq
    CurrentYearQ1QoQActualsSob: partialCompetitor.CurrentYearQ1QoQActualsSob ?? null,
    CurrentYearQ2QoQActualsSob: partialCompetitor.CurrentYearQ2QoQActualsSob ?? null,
    CurrentYearQ3QoQActualsSob: partialCompetitor.CurrentYearQ3QoQActualsSob ?? null,
    CurrentYearQ4QoQActualsSob: partialCompetitor.CurrentYearQ4QoQActualsSob ?? null,
    PrevYearQ1QoQActualsSob: partialCompetitor.PrevYearQ1QoQActualsSob ?? null,
    PrevYearQ2QoQActualsSob: partialCompetitor.PrevYearQ2QoQActualsSob ?? null,
    PrevYearQ3QoQActualsSob: partialCompetitor.PrevYearQ3QoQActualsSob ?? null,
    PrevYearQ4QoQActualsSob: partialCompetitor.PrevYearQ4QoQActualsSob ?? null,
  }
}
